import FormField from '../FormField';
import styles from './styles.module.scss';

function InformationPreview({ formData, handleChange }) {
  const { selectedForm } = formData;

  const onSubmitChange = (id, value) =>
    handleChange({ target: { name: id, value } });

  const renderFields = formData[selectedForm].fields
    .filter((item) => item.isPreview)
    .map((item, index) => (
      <FormField
        isEditable={true}
        key={index}
        label={item.label}
        value={item.value}
        id={item.id}
        handleSubmitChange={onSubmitChange}
        error={item.error}
      />
    ));

  return <div className={styles.user_info_preview}>{renderFields}</div>;
}

export default InformationPreview;
